export const radius = {
  none: 0,
  xs: 4,
  sm: 6,
  md: 10,
  lg: 14,
  xl: 18,
  pill: 9999,
  card: 14,
  button: 12,
  input: 10,
  dialog: 16,
  badge: 8,
  avatar: 9999,
  chip: 9999,
};
